/* eslint-disable no-useless-escape */

import {IObjectStyle, Languages} from './types';
import {_t} from './translations';
import {baseCdnUrl} from './request';
import {DateTime, DurationObjectUnits} from 'luxon';
import {IWidgetTypeId2WidgetClassName, WidgetClassNames, rtWidgets} from '../index';

export enum enviromentTypes {
  production = 'production',
  staging = 'staging',
  development = 'development',
}

// Select widget type for local development.
export const showComponentForLocalDevelopment = (widgetClassName: WidgetClassNames): boolean => {
  // Local development only
  if (process.env.NODE_ENV !== enviromentTypes.development) {
    return true;
  }

  // Check if env variable exists
  if (!process.env.REACT_APP_WIDGET_TYPE_ID) {
    return false;
  }

  const widgetTypeId2WidgetClassNameItem = rtWidgets.find((item: IWidgetTypeId2WidgetClassName) => item.widgetClassName === widgetClassName);
  if (typeof widgetTypeId2WidgetClassNameItem === 'undefined') {
    return false;
  }

  return widgetTypeId2WidgetClassNameItem.widgetTypId === parseInt(process.env.REACT_APP_WIDGET_TYPE_ID)
}

export function isValidHttpUrl(str: string): boolean {
  try {
    const url = new URL(str)
    return url.protocol === "http:" || url.protocol === "https:"
  } catch (_) {
    return false;
  }
}

export function applyCustomStyling(widgetStyles: IObjectStyle[]): void {
  if (typeof window.siwStyles !== 'undefined') {
    // Set styles from VueJs
    window.siwStyles.forEach(style => {
      document.documentElement.style.setProperty(style.type, style.value);
    });
  } else {
    // Set styling from widget response
    widgetStyles.forEach(style => {
      document.documentElement.style.setProperty(style.type, style.value);
    });
  }
}

export function slugify(str: string) {
  // Replace some Unicode chars with ASCII.
  str = replaceArr(
    str,
    ['À', 'Á', 'Â', 'Ã', 'Ä', 'Å', 'Æ', 'Ç', 'È', 'É', 'Ê', 'Ë', 'Ì', 'Í', 'Î', 'Ï', 'Ð', 'Ñ', 'Ò', 'Ó', 'Ô', 'Õ', 'Ö', 'Ø', 'Ù', 'Ú', 'Û', 'Ü', 'Ý', 'ß', 'à', 'á', 'â', 'ã', 'ä', 'å', 'æ', 'ç', 'è', 'é', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó', 'ô', 'õ', 'ö', 'ø', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ', 'Ā', 'ā', 'Ă', 'ă', 'Ą', 'ą', 'Ć', 'ć', 'Ĉ', 'ĉ', 'Ċ', 'ċ', 'Č', 'č', 'Ď', 'ď', 'Đ', 'đ', 'Ē', 'ē', 'Ĕ', 'ĕ', 'Ė', 'ė', 'Ę', 'ę', 'Ě', 'ě', 'Ĝ', 'ĝ', 'Ğ', 'ğ', 'Ġ', 'ġ', 'Ģ', 'ģ', 'Ĥ', 'ĥ', 'Ħ', 'ħ', 'Ĩ', 'ĩ', 'Ī', 'ī', 'Ĭ', 'ĭ', 'Į', 'į', 'İ', 'ı', 'Ĳ', 'ĳ', 'Ĵ', 'ĵ', 'Ķ', 'ķ', 'Ĺ', 'ĺ', 'Ļ', 'ļ', 'Ľ', 'ľ', 'Ŀ', 'ŀ', 'Ł', 'ł', 'Ń', 'ń', 'Ņ', 'ņ', 'Ň', 'ň', 'ŉ', 'Ō', 'ō', 'Ŏ', 'ŏ', 'Ő', 'ő', 'Œ', 'œ', 'Ŕ', 'ŕ', 'Ŗ', 'ŗ', 'Ř', 'ř', 'Ś', 'ś', 'Ŝ', 'ŝ', 'Ş', 'ş', 'Š', 'š', 'Ţ', 'ţ', 'Ť', 'ť', 'Ŧ', 'ŧ', 'Ũ', 'ũ', 'Ū', 'ū', 'Ŭ', 'ŭ', 'Ů', 'ů', 'Ű', 'ű', 'Ų', 'ų', 'Ŵ', 'ŵ', 'Ŷ', 'ŷ', 'Ÿ', 'Ź', 'ź', 'Ż', 'ż', 'Ž', 'ž', 'ſ', 'ƒ', 'Ơ', 'ơ', 'Ư', 'ư', 'Ǎ', 'ǎ', 'Ǐ', 'ǐ', 'Ǒ', 'ǒ', 'Ǔ', 'ǔ', 'Ǖ', 'ǖ', 'Ǘ', 'ǘ', 'Ǚ', 'ǚ', 'Ǜ', 'ǜ', 'Ǻ', 'ǻ', 'Ǽ', 'ǽ', 'Ǿ', 'ǿ'],
    ['A', 'A', 'A', 'A', 'A', 'Aa', 'AE', 'C', 'E', 'E', 'E', 'E', 'I', 'I', 'I', 'I', 'D', 'N', 'O', 'O', 'O', 'O', 'O', 'Oe', 'U', 'U', 'U', 'U', 'Y', 's', 'a', 'a', 'a', 'a', 'a', 'aa', 'ae', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'oe', 'u', 'u', 'u', 'u', 'y', 'y', 'A', 'a', 'A', 'a', 'A', 'a', 'C', 'c', 'C', 'c', 'C', 'c', 'C', 'c', 'D', 'd', 'D', 'd', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'G', 'g', 'G', 'g', 'G', 'g', 'G', 'g', 'H', 'h', 'H', 'h', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'IJ', 'ij', 'J', 'j', 'K', 'k', 'L', 'l', 'L', 'l', 'L', 'l', 'L', 'l', 'l', 'l', 'N', 'n', 'N', 'n', 'N', 'n', 'n', 'O', 'o', 'O', 'o', 'O', 'o', 'OE', 'oe', 'R', 'r', 'R', 'r', 'R', 'r', 'S', 's', 'S', 's', 'S', 's', 'S', 's', 'T', 't', 'T', 't', 'T', 't', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'W', 'w', 'Y', 'y', 'Y', 'Z', 'z', 'Z', 'z', 'Z', 'z', 's', 'f', 'O', 'o', 'U', 'u', 'A', 'a', 'I', 'i', 'O', 'o', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'A', 'a', 'AE', 'ae', 'O', 'o']
  );

  // Replace non-letter or digits with '-'.
  str = str.replace(/[^a-zA-Z0-9]+/ig, "-");

  // Trim '-' from begin and end.
  str = str.replace(/(^-+)|(-+$)/g, "");

  return str.toLowerCase();
}

function replaceArr(str: string, find: any, replace: any) {
  if (find.constructor !== Array) {
    find = [find];
  }
  let replaceWith;
  for (let i = 0; i < find.length; i++) {
    replaceWith = (replace.constructor === Array) ? replace[i] : replace;
    str = str.replace(new RegExp(escapeRegExp(find[i]), "g"), replaceWith);
  }
  return str;
}

function escapeRegExp(str: string) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

// Validate string as integer
// More info: https://stackoverflow.com/a/21070520
function isNumeric(str: string): boolean {
  return /^\d+$/.test(str)
}

// Get eventID from SEO URL
// Example: From "https://site.com/match-page/#/tennis/dominik-koepfer-quentin-halys/24807064/" will return 24807064
export function getEventIdFromSeoUrl(url: string): number {
  const eventID = url.split('#/').slice(-1)[0].split('/').find(urlPart => isNumeric(urlPart));

  if (eventID && isNumeric(eventID)) {
    return parseInt(eventID);
  }

  throw _t('Cant get Event ID from url');
}

// CDN assets url
export function generateCdnAssetsUrl(path: string): string {
  return `${baseCdnUrl}/assets/${path}`;
}

// CDN image proxy
export function generateCdnProxyImageUrl(imageUrl: string): string {
  return `${baseCdnUrl}/imageproxy/?url=${imageUrl}`;
}

// Make name to Adjective
export function makeNameAdjective(name: string, languageId: number): string {
  if (name) {
    const lastLetter = name.charAt(name.length - 1);
    switch (languageId) {
      case Languages.en:
        return (lastLetter === 's') ? name + "'" : name + "'s";

      case Languages.da:
        if (lastLetter !== 's' && lastLetter !== 'z') {
          return name + 's';
        }
        break;
    }
  }

  return name;
}

export function isMobile() {
  return window.innerWidth < 500; //px
}

export function isTablet() {
  return window.innerWidth < 1100; //px
}


export const timeDifference = (endTime: string, timeFormat: keyof DurationObjectUnits) => {
  return DateTime.fromISO(endTime)
  .diff(DateTime.local())
  .shiftTo(timeFormat)
  .toObject();
}

// Source: https://stackoverflow.com/a/24500441
export const getTimeZone = (): string => {
  const z = (n: number): string => (n < 10 ? '0' : '') + n;
  let offset = new Date().getTimezoneOffset();
  const sign = offset < 0 ? '+' : '-';
  offset = Math.abs(offset);
  return `GMT${sign + z(offset / 60 | 0) + z(offset % 60)}`;
}

export const getOrdinalNumberSuffix = (number: string): string => {
  let suffix = ''

  switch (number[number.length - 1]) {
    case '1':
      suffix = 'st'
      break
    case '2':
      suffix = 'nd'
      break
    case '3':
      suffix = 'rd'
      break
    default:
      suffix = 'th'
      break
  }

  return suffix
}
